// CalendarHeatmap.js
import React from "react";
import { Row, Col } from "react-bootstrap";
import "../../css/CalendarHeatmap.css";
const CalendarHeatmap = ({ date, expensesItems, setViewMode, setCurrentDate }) => {
  const year = date.getFullYear();
  const month = date.getMonth();

  // Get the first day of the month and last day of the month
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);

  // Create array of all days to display (including previous/next month days)
  const days = [];
  const startDay = new Date(firstDay);
  startDay.setDate(startDay.getDate() - startDay.getDay()); // Start from Sunday

  const endDay = new Date(lastDay);
  endDay.setDate(endDay.getDate() + (6 - endDay.getDay())); // End on Saturday

  // Get maximum expense for color scaling
  const maxExpense = Math.max(...expensesItems.map((item) => Number(item.total) || 0));

  // Generate all days in the heatmap view
  while (startDay <= endDay) {
    days.push(new Date(startDay));
    startDay.setDate(startDay.getDate() + 1);
  }

  // Create color classes based on expense intensity
  const MAX_COLOR_INTENSE = 10;
  const getColorClass = (amount) => {
    if (amount === 0) return "heatmap-day-0";
    const intensity = Math.min(Math.floor((amount / maxExpense) * MAX_COLOR_INTENSE) + 1, MAX_COLOR_INTENSE);
    return `heatmap-day-${intensity}`;
  };

  return (
    <div className="heatmap-container">
      <Row className="heatmap-week">
        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
          <Col key={day} className="heatmap-day-header">
            {day}
          </Col>
        ))}
      </Row>

      {Array.from({ length: Math.ceil(days.length / 7) }).map((_, weekIndex) => (
        <Row key={weekIndex} className="heatmap-week">
          {days.slice(weekIndex * 7, (weekIndex + 1) * 7).map((day) => {
            const formattedDate = day.toISOString().split("T")[0];
            const isCurrentMonth = day.getMonth() === month;
            const itemsForDay = expensesItems.filter((item) => item.purchasedDate === formattedDate);
            const totalAmount = itemsForDay.reduce((sum, item) => sum + Number(item.total || 0), 0);

            return (
              <Col
                key={day}
                className={`heatmap-day ${getColorClass(totalAmount)} ${!isCurrentMonth ? "other-month" : ""}`}
                onClick={() => {
                  setViewMode("day");
                  setCurrentDate(day);
                }}
                title={`${day.toLocaleDateString()}: $${totalAmount.toFixed(2)}`}
              >
                <div className="heatmap-day-content">
                  {day.getDate()}
                  <div className="heatmap-amount">${totalAmount.toFixed(0)}</div>
                </div>
              </Col>
            );
          })}
        </Row>
      ))}
    </div>
  );
};

export default CalendarHeatmap;
